// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const ORDERS_REQUEST = 'ORDERS_REQUEST';
const ORDERS_REQUEST_SUCCESS = 'ORDERS_REQUEST_SUCCESS';
const ORDERS_REQUEST_FAILED = 'ORDERS_REQUEST_FAILED';

const ORDERS_START_LOADING = 'ORDERS_START_LOADING';
const ORDERS_STOP_LOADING = 'ORDERS_STOP_LOADING';

const ORDERS_RESET = 'ORDERS_RESET';


export {
  ORDERS_REQUEST,
  ORDERS_REQUEST_SUCCESS,
  ORDERS_REQUEST_FAILED,

  ORDERS_START_LOADING,
  ORDERS_STOP_LOADING,

  ORDERS_RESET,
};
